import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-condition-component',
  templateUrl: './terms-condition-component.component.html',
  styleUrls: ['./terms-condition-component.component.css']
})
export class TermsConditionComponentComponent implements OnInit {

  isLogin = 'false';
  privacyPolicyClass;
  constructor() { }

  ngOnInit() {
    document.documentElement.scrollTop = 0;
    this.isLogin = localStorage.getItem('isLogin');
    this.setClass();
  }

  setClass() {
    if (this.isLogin === 'true') {
      this.privacyPolicyClass = 'privacy-m-top';
    } else {
      this.privacyPolicyClass = 'privacy-policy-main';
    }
  }

}
